/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Greek12Inputs */

const en__field_enum_subject_greek12 = /** @type {(inputs: _Field_Enum_Subject_Greek12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greek`)
};

const de__field_enum_subject_greek12 = /** @type {(inputs: _Field_Enum_Subject_Greek12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griechisch`)
};

/**
* | output |
* | --- |
* | "Greek" |
*
* @param {_Field_Enum_Subject_Greek12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_greek12 = /** @type {((inputs?: _Field_Enum_Subject_Greek12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Greek12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_greek12(inputs)
	return de__field_enum_subject_greek12(inputs)
});
export { _field_enum_subject_greek12 as "_field_enum_SUBJECT_GREEK" }